<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      left
      temporary
      width="100%"
      class="nav-mobile"
    >
      <v-row class="no-margin">
        <v-col cols="12" class="header-nav-mobile">
          <span class="title-box text-uppercase pl-2">{{ $t('menu') }}</span>
          <v-spacer></v-spacer>
          <v-icon @click.stop="drawer = !drawer" large class="pr-4"
            >mdi-close</v-icon
          >
        </v-col>
        <v-divider></v-divider>
        <v-col cols="12" class="bordered-element left-module-mobile">
          <LeftModule></LeftModule>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="drawer_cart"
      absolute
      top
      temporary
      height="100%"
      width="100%"
      style="margin-top: 5%"
    >
      <v-row class="no-margin">
        <v-col cols="12" class="text-right pt-4 pr-4 pb-0">
          <v-spacer></v-spacer>
          <v-icon @click.stop="drawer_cart = !drawer_cart">mdi-close</v-icon>
        </v-col>
        <v-col cols="12" sm="2" md="2" class="bordered-element">
          <RightModule></RightModule>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <v-bottom-navigation color="primary" fixed dense dark>
      <v-row dense>
        <v-col cols="3" class="no-padding d-flex-center-all">
          <v-btn>
            <span class="text-white text-small text-capitalize">{{
              $t('menu')
            }}</span>
            <v-icon
              color="white"
              dense
              style="padding-bottom: 5px"
              @click.stop="drawer = !drawer"
              >mdi-menu</v-icon
            >
          </v-btn>
        </v-col>

        <v-col cols="3" class="no-padding d-flex-center-all">
          <v-btn @click="changeLiveMode('detail')">
            <span class="text-white text-small">{{ $t('live') }}</span>
            <v-icon dense style="padding-bottom: 5px">mdi-alarm-plus</v-icon>
            <span
              class="num-odds-mobile num-odds-mobile-live"
              v-if="this.getTotalCountLive() > 0"
              >{{ this.getTotalCountLive() }}</span
            >
          </v-btn>
        </v-col>

        <v-col cols="3" class="no-padding d-flex-center-all">
          <v-btn>
            <span class="text-white text-small">{{ $t('betSlip') }}</span>
            <v-icon
              color="white"
              dense
              style="padding-bottom: 5px"
              @click.stop="drawer_cart = !drawer_cart"
              >mdi-file-document</v-icon
            >
            <span
              class="num-odds-mobile num-odds-mobile-cart"
              v-if="getBet.odds.length > 0"
              >{{ getBet.odds.length }}</span
            >
          </v-btn>
        </v-col>

        <v-col cols="3" class="no-padding d-flex-center-all">
          <v-btn @click="search">
            <span class="text-white text-small">{{ $t('search') }}</span>
            <v-icon color="white" dense style="padding-bottom: 5px"
              >mdi-magnify</v-icon
            >
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>

    <v-row justify="center">
      <v-dialog
        v-if="!getModalIdle"
        v-model="dialogSearch"
        max-width="290"
        origin="top center"
        style="position: absolute; top: 0"
      >
        <v-card class="pa-2">
          <Search></Search>
          <v-card-text class="pa-2">
            {{ $t('searchHelp') }}
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LeftModule from '@/components/Left.vue'
import Search from '@/components/generic/Search'
import CenterModule from '@/components/Center'
import RightModule from '@/components/Right'

export default {
  name: 'BottomNavigationMobile',
  data: () => ({
    drawer: false,
    drawer_cart: false,
    count_live_total: '',
    dialogSearch: false,
  }),
  components: {
    Search,
    LeftModule,
    CenterModule,
    RightModule,
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getBet: 'cart/getBet',
      getCountLive: 'odds/getCountLive',
      getModalIdle: 'user/getModalIdle',
    }),
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
    }),

    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },

    getTotalCountLive() {
      let total = 0
      _.forEach(this.getCountLive, count => {
        total += count.count
      })
      return total
    },

    search() {
      this.dialogSearch = true
    },
  },

  mounted() {
    const vm = this
    this.$root.$on('close_sidebar_left', function (value) {
      if (value) {
        vm.drawer = !vm.drawer
      }
    })

    this.$root.$on('close_search', function (value) {
      if (value) {
        vm.dialogSearch = !vm.dialogSearch
      }
    })
  },
}
</script>
